<div class="badge-accepts-new-patients">
  <svg viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.42188 11.7031C5.73438 12.0156 6.26563 12.0156 6.57813 11.7031L15.7656 2.51562C16.0781 2.20312 16.0781 1.67188 15.7656 1.35938L14.6406 0.234375C14.3281 -0.078125 13.8281 -0.078125 13.5156 0.234375L6.01563 7.73438L2.48438 4.23438C2.17188 3.92188 1.67188 3.92188 1.35938 4.23438L0.234375 5.35938C-0.078125 5.67188 -0.078125 6.20313 0.234375 6.51563L5.42188 11.7031Z"
    />
  </svg>
  Accepting new patients
</div>
